import ProxyBase from '../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getHighlight(params) {
    return this.get('Hightlight', params)
  }

  getOverdueTaxDebt(params) {
    return this.get('OverdueTaxDebt', params)
  }

  getOverdueSocialInsurance(params) {
    return this.get('OverdueSocialInsurance', params)
  }

  exportOverdueTaxDebt(params) {
    return this.post('OverdueTaxDebt/Export', params, {}, 'download')
  }

  exportOverdueSocialInsurance(params) {
    return this.post('OverdueSocialInsurance/Export', params, {}, 'download')
  }
}

export default new Proxy('FilingStatus/')
